import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { IconButton } from 'atoms/buttons/IconButton';
import { Vertical } from 'atoms/layout/flex';
import { BrandXS } from 'atoms/typography';
import { Chip } from 'atoms/ui/Chip';
import { Dialog } from 'components/dialog';
import { EnergyOnboardingInfoModal } from 'components/onboarding/EnergyOnboardingInfoModal';
import { glossary } from 'lib/glossary';

const Wrapper = styled(Vertical)`
  padding: var(--triple-unit);
`;

const IconButtonWrapper = styled.div`
  position: absolute;
  top: var(--unit);
  right: var(--unit);
`;

const NewChip = styled(Chip)`
  background: linear-gradient(319deg, #1510ff 16.49%, #00fff7 82.68%);
`;

type Props = {
  open: boolean;
  onClose: () => void;
};

export const EnergyBalanceHelp = ({ open, onClose }: Props) => {
  return (
    <Dialog
      hideHeader
      open={open}
      maxWidth="xs"
      onClose={onClose}
      title={
        <NewChip>
          <BrandXS bold>
            <FormattedMessage {...glossary.new} />
          </BrandXS>
        </NewChip>
      }
    >
      <Wrapper gap={1.5}>
        <IconButtonWrapper>
          <IconButton icon={faXmark} onClick={onClose} color="transparent" />
        </IconButtonWrapper>
        <EnergyOnboardingInfoModal />
      </Wrapper>
    </Dialog>
  );
};
